// FN activate link [role button] on space / enter

// see: https://codepen.io/svinkle/pen/wqchm

var fn_role_button = function () {

    var mybutton = $('[role="button"]');

    mybutton.each(function () {

        $(this).on('keydown', function (e) {
            if (e.which === 32 || e.which === 13) {
                e.preventDefault();
                $(this).click();

            }
        });

    });


};
